module.exports = __webpack_public_path__ + "img/premium_05.fe97481a.jpg";